const ORG_BANNER_DENY_PREFIXES = [
  "/my-shifts",
  "/my-schedule",
  "/settings",
  "/admin",
  "/live",
  "/design-system",
  "/learn",
];

/**
 * Detail workspaces carry their organization context in their own compact
 * header, so the global organization banner would repeat the same information.
 */
export function shouldShowOrgBanner(pathname: string): boolean {
  if (/^\/festivals\/[^/]+(?:\/|$)/.test(pathname)) return false;

  return !ORG_BANNER_DENY_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
